"use client";

import getGamesCountLabel from "./helpers/getGamesCountLabel";
import ProviderTile from "./ProviderTile";

type Props = {
  providers: ProviderTileData[];
  gamesCountOneTemplate: string;
  gamesCountManyTemplate: string;
  noResults: string;
  colorScheme: ColorScheme;
};

const ProvidersGridList: FC<Props> = ({
  providers,
  gamesCountOneTemplate,
  gamesCountManyTemplate,
  noResults,
  colorScheme,
}) => {
  if (!providers.length) {
    return (
      <p className="py-8 text-center text-sm/6 text-muted-foreground">
        {noResults}
      </p>
    );
  }

  return (
    <div
      data-slot="providers-grid-list"
      className="grid grid-cols-2 gap-3 sm:grid-cols-3! md:grid-cols-4! lg:grid-cols-5! xl:grid-cols-6! 2xl:grid-cols-7!"
    >
      {providers.map((provider) => (
        <ProviderTile
          key={provider.id}
          provider={provider}
          gamesCountLabel={getGamesCountLabel(provider.count, {
            gamesCountOne: gamesCountOneTemplate,
            gamesCountMany: gamesCountManyTemplate,
          })}
          colorScheme={colorScheme}
        />
      ))}
    </div>
  );
};

export default ProvidersGridList;
